export const InferenceServiceId = {
  EMPTY: 'ai.robovision.services.inference.empty', // FE only concept
  HTTP: 'ai.robovision.services.inference.http',
  OPC: 'ai.robovision.services.inference.opc',
}
